exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".EndNode{position:relative;height:4rem;display:none}@media screen and (min-width:480px){.EndNode{display:block}}.EndNode .date{position:absolute;top:0;left:calc(92% - 1.5rem - .25rem);background-color:#8e9ab2;border-radius:.3rem;font-family:Roboto,sans-serif;border:.25rem solid #f2f2f2;width:3rem;height:3rem;border-radius:6rem;margin:0;color:#fff;font-size:.7rem;margin:0 auto;display:none}@media screen and (min-width:480px){.EndNode .date{display:block}}@media screen and (min-width:768px){.EndNode .date{left:calc(50% - 1.5rem - .25rem)}}.EndNode .horizontal-line{position:absolute;top:0;width:.25rem;height:100%;background-color:#8e9ab2;content:\" \";left:calc(92% - .125rem);display:none}@media screen and (min-width:480px){.EndNode .horizontal-line{display:block}}@media screen and (min-width:768px){.EndNode .horizontal-line{left:calc(50% - .125rem)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/Components/Timeline/EndNode.scss
// module id = 229
// module chunks = 0